export const LOGISTICS_OPL: string = 'opl'; //operatore logistica
export const LOGISTICS_OPC: string = 'opc'; //operatore consultazione
export const LOGISTICS_OPAD: string = 'opad'; //operatore admin
export const LOGISTICS_OPASR: string = 'opasr'; //customer asr
